import React, { useEffect, useRef, useState } from 'react';
import { Html5QrcodeScanner } from 'html5-qrcode';
import { useNavigate } from 'react-router-dom';
import Icon from './Icon';
import './QRScanner.css';

const PRODUIT_ROUTE = {
  saumon:       '/production/saumon',
  cotes_levees: '/production/ribs',
  porc:         '/production/porc',
  brisket:      '/production/brisket',
  saucisses:    '/production/saucisses',
  sauce:        '/production/sauce',
};

const PRODUIT_LABEL = {
  saumon:       'Saumon Fumé',
  cotes_levees: 'Côtes Levées',
  porc:         'Porc Effiloché',
  brisket:      'Brisket',
  saucisses:    'Saucisses',
  sauce:        'Sauce BBQ',
};

export default function QRScanner() {
  const navigate = useNavigate();
  const [result, setResult] = useState(null);
  const [erreur, setErreur] = useState(null);
  const scannerRef = useRef(null);

  useEffect(() => {
    if (result) return;

    const scanner = new Html5QrcodeScanner(
      'qr-reader',
      { fps: 10, qrbox: { width: 250, height: 250 } },
      false
    );

    scanner.render(
      (decoded) => {
        scanner.clear().catch(() => {});
        // Format attendu : ESCAMEL-BATCH-{batchId}-{produit}
        const match = decoded.match(/^ESCAMEL-BATCH-(\d+)-(.+)$/);
        if (match) {
          const [, batchId, produit] = match;
          if (PRODUIT_ROUTE[produit]) {
            setResult({ batchId, produit });
          } else {
            setErreur(`Produit inconnu dans le QR : "${produit}"`);
          }
        } else {
          setErreur('QR non reconnu. Format attendu : ESCAMEL-BATCH-{id}-{produit}');
        }
      },
      () => {} // ignore les erreurs de scan en continu
    );

    scannerRef.current = scanner;

    return () => {
      scanner.clear().catch(() => {});
    };
  }, [result]);

  if (result) {
    const route = PRODUIT_ROUTE[result.produit];
    const label = PRODUIT_LABEL[result.produit] || result.produit;

    return (
      <div className="qr-page">
        <div className="qr-result">
          <div className="qr-result__check">
            <Icon name="check" size={32} weight="bold" />
          </div>
          <h2 className="qr-result__titre">Batch #{result.batchId}</h2>
          <p className="qr-result__produit">{label}</p>
          <div className="qr-result__actions">
            <button
              className="btn btn-primary btn--lg"
              onClick={() => navigate(`${route}?batch=${result.batchId}`)}
            >
              <Icon name="voir" size={16} />
              Ouvrir ce batch
            </button>
            <button
              className="btn btn-ghost"
              onClick={() => { setResult(null); setErreur(null); }}
            >
              <Icon name="rafraichir" size={16} />
              Scanner un autre QR
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="qr-page">
      <div className="qr-header">
        <button className="btn btn-ghost btn--sm" onClick={() => navigate(-1)}>
          <Icon name="retour" size={14} />
          Retour
        </button>
        <h1 className="qr-titre">Scanner un batch</h1>
        <p className="qr-subtitle">Pointez la caméra vers le QR code imprimé sur la fiche batch</p>
      </div>

      {erreur && (
        <div className="qr-erreur">
          <span className="danger">{erreur}</span>
          <button
            className="btn btn-ghost btn--sm"
            onClick={() => setErreur(null)}
          >
            <Icon name="rafraichir" size={14} />
            Réessayer
          </button>
        </div>
      )}

      <div id="qr-reader" className="qr-reader-wrap" />

      <p className="qr-hint">
        Format QR : <code>ESCAMEL-BATCH-{'{id}'}-{'{produit}'}</code>
      </p>
    </div>
  );
}
